import {createStore} from '../utilities/storeUtils';
import  _ from 'underscore';
import {brokerKeyToArrayOfBroker} from './relationships';

let brokers = {};

// let cmrDomains = {};

const defaults = {

};

const BrokerStore = createStore({
  storeEventBaseKey: "brokers",
  normalizr: brokerKeyToArrayOfBroker,
  normalizrKey: "brokers",
  getData(){
    return brokers;
  },
  getDefaults(){
    return defaults;
  },
  getBrokers(){
     return brokers;
  },
  getBroker(id){
    return brokers[id];
  }
});

window.BrokerStore = BrokerStore;
export default BrokerStore;


// WEBPACK FOOTER //
// ./src/stores/BrokerStore.js